export const OPEN_CREATE_EVENTSLIST = "OPEN_CREATE_EVENTSLIST";
export const CLOSE_CREATE_EVENTSLIST = "CLOSE_CREATE_EVENTSLIST";
export const SET_SEARCH_TERM = "SET_SEARCH_TERM";
export const SET_EVENTSLIST_PENDING ="SET_EVENTSLIST_PENDING";
export const SET_EVENTSLIST = "SET_EVETLIST";
export const SET_CREATE_NEW_EVENT_SUCCESS = "SET_CREATE_NEW_EVENT_SUCCESS";
export const SET_NEW_EVENT_ID ="SET_NEW_EVENT_ID";
export const SET_ADDED_QUESTIONS_LIST = "SET_ADDED_QUESTIONS_LIST";
export const SET_NEWEVENT_DATA = "SET_NEWEVENT_DATA";
export const SET_QUESTIONS_REDIRECT = "SET_QUESTIONS_REDIRECT";
export const SET_EDIT_QUESTION_DATA="SET_QUESTION_DATA";
export const REDIRECT_TO_ADD_QUESTION = "REDIRECT_TO_ADD_QUESTION";
export const SET_IS_GET_ADDED_QUESTION_LIST_PENDING = "SET_IS_GET_ADDED_QUESTION_LIST_PENDING";
export const SET_IS_GET_EVENT_DATA_PENDING = "SET_IS_GET_EVENT_DATA_PENDING";
export const SET_IS_GET_EDIT_QUESTION_DATA_PENDING = "SET_IS_GET_EDIT_QUESTION_DATA_PENDING";
export const SET_IS_CREATE_NEW_EVENT_PENDING ="SET_IS_CREATE_NEW_EVENT_PENDING";
export const SET_IS_ADD_QUESTION_DATA_PENDING = "SET_IS_ADD_QUESTION_DATA_PENDING";
export const OPEN_ADD_ORGANIZER = "OPEN_ADD_ORGANIZER";
export const CLOSE_ADD_ORGANIZER = "CLOSE_ADD_ORGANIZER";
export const SET_USER_ORGANIZER = "SET_USER_ORGANIZER";
export const SET_ORGANIZER_PENDING = "SET_ORGANIZER_PENDING";
export const SET_ORGANIZER_LIST = "SET_ORGANIZER_LIST";
export const SET_EVENT_ORGANIZER_PENDING = "SET_EVENT_ORGANIZER_PENDING";
export const OPEN_ADD_EVALUATOR = "OPEN_ADD_EVALUATOR";
export const CLOSE_ADD_EVALUATOR = "CLOSE_ADD_EVALUATOR";
export const GET_EVENT_USERS_PENDING = "GET_EVENT_USERS_PENDING";
export const SET_EVENT_USERS = "SET_EVENT_USERS";
export const SET_EVALUATORS_PENDING = "SET_EVALUATORS_PENDING";
export const SET_EVALUATORS_LIST = "SET_EVALUATORS_LIST";
export const SET_USER_EVALUATOR = "SET_USER_EVALUATOR";
export const SET_EVENT_EVALUATORS_PENDING = "SET_EVENT_EVALUATORS_PENDING";
export const SET_DELETE_ORGANIZER_PENDING = "SET_DELETE_ORGANIZER_PENDING";
export const SET_DELETE_EVALUATOR_PENDING = "SET_DELETE_EVALUATOR_PENDING";
export const SET_UPLOAD_ANSWERVI_VISIBLE = "SET_UPLOAD_ANSWERVI_VISIBLE";
export const INITIALIZE_EDITQUESTIONDATA = "INITIALIZE_EDITQUESTIONDATA";
export const SET_AUTOEVAL_RESULTS = "SET_AUTOEVAL_RESULTS";
export const SET_AUTOEVAL_RESULTS_PENDING = "SET_AUTOEVAL_RESULTS_PENDING";
export const SET_CURRENT_QUESTIONID = "SET_CURRENT_QUESTIONID";
export const SET_AUTOEVAL_INPUTS_VISIBLE = "SET_AUTOEVAL_INPUTS_VISIBLE";
export const SET_UPLOAD_ANSWER_PENDING = "SET_UPLOAD_ANSWER_PENDING";
export const SET_IS_EVALUATED = "SET_IS_EVALUATED";
export const SET_SAVE_TESTCASE = "SET_SAVE_TESTCASE";
export const SET_EVENT_EDITED_STATUS = "SET_EVENT_EDITED_STATUS";
export const SET_CONFIG_FILE_PENDING = "SET_CONFIG_FILE_PENDING";
export const SET_SAVEFILES_PENDING = "SET_SAVEFILES_PENDING";
export const SET_GAME_DATA_PENDING = "SET_GAME_DATA_PENDING";
export const SET_GAME_DATA = "SET_GAME_DATA";
export const SET_GAME_TITLECARD_PENDING = "SET_GAME_TITLECARD_PENDING";
export const SET_GAME_TITLECARD = "SET_GAME_TITLECARD";
export const OPEN_INSTRUCTIONS_MODAL = "OPEN_INSTRUCTIONS_MODAL";
export const CLOSE_INSTRUCTIONS_MODAL = "CLOSE_INSTRUCTIONS_MODAL";
export const SET_UPLOAD_TITLCARD_PENDING = "SET_UPLOAD_TITLCARD_PENDING";
export const SET_UPLOAD_PLUGIN_PENDING = "SET_UPLOAD_PLUGIN_PENDING";
export const SET_UPLOAD_ENGINE_PENDING = "SET_UPLOAD_ENGINE_PENDING";
export const SET_UPLOAD_PLAYERVI_PENDING = "SET_UPLOAD_PLAYERVI_PENDING";
export const SET_UPLOAD_OPPPLAYERVI_PENDING = "SET_UPLOAD_OPPPLAYERVI_PENDING";
export const SET_SAVEGAMESETAILS_PENDING = "SET_SAVEGAMESETAILS_PENDING";
export const SET_EXECUTEGAME_PENDING = "SET_EXECUTEGAME_PENDING";
export const SET_SHOW_GAME = "SET_SHOW_GAME";
export const SET_DOWNLOAD_ENGINE_URL = "SET_DOWNLOAD_ENGINE_URL";
